import { DataTableColumnHeader } from "@/components/DataTable/Columns/DataTableColumnHeader";
import type { HelperOptions } from "@/components/DataTable/types";
import type { ColumnDef } from "@tanstack/react-table";
import type { AppUserTableRow } from "../../types";
import { AppUserActionButton } from "./AppUserActionButton";

type SuggestedActionColumnOptions = HelperOptions & {
  appIntegrationId?: string;
  appName?: string;
  onSuccess?: () => void;
};

/** アサインメントルールとの合致条件に応じてDressCodeが操作者に推奨するアクションを表示するためのカラムコンポーネント */
export function SuggestedActionColumn(
  options: SuggestedActionColumnOptions = {},
): ColumnDef<AppUserTableRow> {
  const { minWidth, appIntegrationId = "", appName = "", onSuccess } = options;

  return {
    id: "suggestedAction",
    meta: { i18nKey: "action", thStyle: { minWidth } },
    header: (props) => <DataTableColumnHeader {...props} />,
    cell: ({ row }) => {
      const rowData = row.original;
      return rowData.action ? (
        <AppUserActionButton
          appIntegrationId={appIntegrationId}
          appUserId={rowData.user?.id}
          personId={rowData.person?.id}
          appName={appName}
          action={rowData.action}
          onSuccess={onSuccess}
        />
      ) : (
        "-"
      );
    },
  };
}
